module.exports = __webpack_public_path__ + "static/media/pullstation.3de49a83.png";